import { Card, Typography } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import type { VarietyBreakdown } from "../../types/adjacent-crop";

const { Title } = Typography;

interface Props {
  data: VarietyBreakdown[];
  loading?: boolean;
}

const COLORS = [
  "#1890ff",
  "#52c41a",
  "#faad14",
  "#ff4d4f",
  "#722ed1",
  "#13c2c2",
  "#eb2f96",
  "#fa8c16",
];

export const VarietyBreakdownChart = ({ data, loading }: Props) => {
  // Transform data for stacked bar chart
  // Each species becomes a row, each variety becomes a bar segment
  const chartData = data.map((speciesData) => {
    const row: any = { species: speciesData.species };
    speciesData.varieties.forEach((variety) => {
      row[variety.name] = variety.count;
    });
    return row;
  });

  // Get all unique variety names for the legend
  const allVarieties = new Set<string>();
  data.forEach((speciesData) => {
    speciesData.varieties.forEach((variety) => {
      allVarieties.add(variety.name);
    });
  });
  const varietyNames = Array.from(allVarieties);

  return (
    <Card loading={loading}>
      <Title level={5}>Desglose de Variedades por Especie</Title>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="species" />
          <YAxis />
          <Tooltip />
          <Legend />
          {varietyNames.map((varietyName, index) => (
            <Bar
              key={varietyName}
              dataKey={varietyName}
              stackId="a"
              fill={COLORS[index % COLORS.length]}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};
